import React,  { useRef } from "react";
import w3_33 from "../../assets/w3_33.jpg";
import w3_35 from "../../assets/w3_35.jpg";
import w3_39 from "../../assets/w3_39.jpg";
import w3_42 from "../../assets/w3_42.jpg";
import w3_51 from "../../assets/w3_51.jpg";
import w3_53 from "../../assets/w3_53.jpg";
import w3_54 from '../../assets/w3_54.jpg';
import w3_55 from '../../assets/w3_55.jpg';
import w3_57 from '../../assets/w3_57.jpg';
import w3_58 from '../../assets/w3_58.jpg';
import w3_59 from '../../assets/w3_59.jpg';
import w3_62 from '../../assets/w3_62.jpg';
import w3_75 from '../../assets/w3_75.jpg';
import w3_77 from '../../assets/w3_77.jpg';
import w3_63 from '../../assets/w3_63.jpg';
import w3_68 from '../../assets/w3_68.jpg';
import w_80 from '../../assets/w_80.jpg';
import dxf from '../../assets/dxf.png';
import w3_5 from '../../assets/w3_5.jpg';
import v1 from '../../assets/v1.jpg';
import v2 from '../../assets/v2.jpg';
import v3 from '../../assets/v3.jpg';
import v4 from '../../assets/v4.jpg';
import v5 from '../../assets/v5.jpg';
import v6 from '../../assets/v6.jpg';
import v7 from '../../assets/v7.jpg';
import v8 from '../../assets/v8.jpg';
import v9 from '../../assets/v9.jpg';
import v10 from '../../assets/v10.jpg';
import v11 from '../../assets/v11.jpg';
import v12 from '../../assets/v12.jpg';
import v13 from '../../assets/v13.jpg';
import IMG_20250207_171039_828 from '../../assets/IMG_20250207_171039_828.jpg';
import IMG_20250207_171736_461 from '../../assets/IMG_20250207_171736_461.jpg';
import IMG_20250207_172821_666 from '../../assets/IMG_20250207_172821_666.jpg';
import w_8 from '../../assets/w_8.jpg';
import final_pck from '../../assets/final_pck.jpg';
import headerImage from "../../assets/header_3.jpg";
import smallVideo from '../../assets/small_video.mp4';
import focus from '../../assets/focus.mp4';
import GA1 from '../../assets/GA_1.jpg';
import GA2 from '../../assets/GA_2.jpg';
import GA3 from '../../assets/GA_3.jpg';
import GA4 from '../../assets/GA_4.jpg';
import GA5 from '../../assets/GA_5.jpg';
import GA6 from '../../assets/GA_6.jpg';
import GA7 from '../../assets/GA_7.jpg';
import GA8 from '../../assets/GA_8.jpg';
import GA9 from '../../assets/GA_9.png';
import GA10 from '../../assets/GA_10.jpg';
import GA11 from '../../assets/GA_11.jpg';
import GA12 from '../../assets/GA_12.jpg';
import GA13 from '../../assets/GA_13.jpg';
import GA14 from '../../assets/GA_14.jpg';
import GA15 from '../../assets/GA_15.jpg';




const Assignment4 = () => {
  const paraConstrKit = useRef(null);
  const result = useRef(null);
  const vinylCutting = useRef(null);
  const groupAssignment = useRef(null);

  const scrollToSection = (ref) => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };


    
  return (

    <div className="container mx-auto my-8 px-5 max-w-3xl bg-gray-100 p-8 rounded-lg shadow-md">
      {/* Header */}
      <div className="relative mb-8">
        <img
          src={headerImage}
          alt="Header"
          className="w-full h-64 object-cover rounded-lg shadow-md  object-cover filter grayscale brightness-75"
        />
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent p-4 rounded-b-lg">
          <h1 className="text-4xl font-bold text-bg-secondary"  style={{ textShadow: '2px 2px 4px rgba(0, 0, 0, 1)' }}>3. Week - Computer-Controlled Cutting</h1>
          <p className="text-gray-300 mt-2">Published on: <span className="font-semibold">February 11, 2025</span></p>
          <div className="mt-4 flex space-x-4">
         {/* Navigation Links */}
      <div className="mt-4 flex space-x-4">
        <button onClick={() => scrollToSection(paraConstrKit)} className="text-white bg-secondary px-3 py-1 rounded hover:bg-secondary">
          Parametric Construction Kit
        </button>
        <button onClick={() => scrollToSection(result)} className="text-white bg-secondary px-3 py-1 rounded hover:bg-secondary">
          Result
        </button>
        <button onClick={() => scrollToSection(vinylCutting)} className="text-white bg-secondary px-3 py-1 rounded hover:bg-secondary">
          Vinyl Cutting
        </button>
        <button onClick={() => scrollToSection(groupAssignment)} className="text-white bg-secondary px-3 py-1 rounded hover:bg-secondary">
          Group Assignment
        </button>
        </div>
        </div>
        </div>
        </div>
        <p className="text-justify text-gray-700 mb-6">
        This week, we are exploring computer-controlled cutting using a laser cutter and a vinyl cutter. The focus is on understanding how digital designs can be precisely cut into different materials.</p>
        <p className="text-justify text-gray-700 mb-6">
        In the group assignment, we go through safety training and test different laser cutter settings, such as focus, power, speed, and kerf, to understand how they affect the final result.</p>
        <p className="text-justify text-gray-700 mb-6">
        For the individual assignment, we create a parametric construction kit, which allows us to design interlocking pieces that fit together without glue. We also get hands-on experience with the vinyl cutter, cutting out custom designs.</p>
        <p className="text-justify text-gray-700 mb-6">
        By the end of the week, we will have a better understanding of how to prepare files for cutting, how material properties influence the cutting process, and how to create precise and functional designs. </p>

        {/* Parametric Construction Kit Section*/}
        <div ref={paraConstrKit}>
        <h2 className="text-3xl font-bold text-center mb-6">Parametric Construction Kit</h2>
      <p className="text-justify text-gray-700 mb-6">
      This part of the assignment is the design of a parametric construction kit designed for laser cutting or CNC milling, allowing for modular and tool-free assembly. The design consists of interlocking vertical panels that fit precisely into slots in a circular base plate, enabling various configurations and heights. The use of parametric constraints in Fusion 360 ensures that the kit remains flexible, allowing adjustments to dimensions such as slot width, amout of slots, panel height, material strength and kerf without requiring a complete redesign. </p>
      <h3>1. Designing the Base Plate</h3>
      <p className="text-justify text-gray-700 mb-6">
The first step in creating the construction kit was to design the base plate, which serves as the foundation for the interlocking vertical panels.
To begin, a new sketch was created on the XY-plane, where the overall shape of the base was defined as a circle with a diameter parameter (diameter_bottom).
This parameter allows the base size to be easily modified at any stage of the design process.
</p>

<img src={w3_33} alt="Image Base Plate" className="my-4 mx-auto rounded shadow-md" />

      <p className="text-justify text-gray-700 mb-6">Once the base shape was set, slots for the vertical panels were added.
The slot was assigned a slot width parameter (slot_width) to ensure that the vertical panels would fit snugly, and a slot depth parameter (material_strength - kerf) to determine
how deep each panel would sit in the base. 

<img src={w3_35} alt="Image Base Plate Slots" className="my-4 mx-auto rounded shadow-md" />

To distribute the slots evenly around the circular base, the "Circular Pattern" tool was used with the parameter "amount_of_slots", making it easy to modify
the number of slots if needed.
<img src={w3_39} alt="Circular Pattern" className="my-4 mx-auto rounded shadow-md" />
With the slot pattern complete, the sketch was finished and negatively extruded to the defined thickness parameter (material_strength), which was set based on the material intended for fabrication (initially to 3mm). The use of parameters ensured that any changes to the material thickness could be applied instantly to all related components and the cut-outs for the slots.</p>

<img src={w3_42} alt="Extrusion" className="my-4 mx-auto rounded shadow-md" />
      

      <h2>2. Creating the Interlocking Vertical Panels</h2>
      <p className="text-justify text-gray-700 mb-6">
Once the base plate was finalized, the next step was to design the vertical panels that would fit into the slots. First a side profile was created in a new sketch on the XZ-plane. To ensure that the base and vertical panels would fit perfectly together, the slot geometry from the base plate was projected into the new sketch using the "Project" (P) tool.
</p>
<img src={w3_51} alt="P Tool" className="my-4 mx-auto rounded shadow-md" />
  


      <h3>Extruding and Expanding the Slots</h3>
<p class="text-justify text-gray-700 mb-6">
    Next, I extruded the slots and widened them at the top of the plate. To create a curved and visually appealing effect, I used an <strong>arc</strong> and set its height to the parameter <code>plate_distance</code>. After that, I modeled the counterpart with the corresponding dimensions of the slots.
</p>
<img src={w3_54} alt="Extruded Slot" class="my-4 mx-auto rounded shadow-md" />
<img src={w3_55} alt="Slot Expansion" class="my-4 mx-auto rounded shadow-md" />

<p class="text-justify text-gray-700 mb-6">
    The <strong>Circular Pattern</strong> tool was again used to arrange the columns according to the slot positions.
</p>
<img src={w3_57} alt="Circular Pattern for Columns" class="my-4 mx-auto rounded shadow-md" />

<h3>Designing the Upper Plate</h3>
<p class="text-justify text-gray-700 mb-6">
    Next, I constructed the upper plate in the same way as the lower one but assigned a different parameter for its diameter, giving it a larger value.
</p>
<img src={w3_58} alt="Upper Plate Design" class="my-4 mx-auto rounded shadow-md" />

<p class="text-justify text-gray-700 mb-6">
    Just like the lower plate, I extruded the upper plate and drew the slots, arranging them using the <strong>Circular Pattern</strong> tool.
</p>
<img src={w3_59} alt="Upper Plate Extrusion and Slot Pattern" class="my-4 mx-auto rounded shadow-md" />

<p class="text-justify text-gray-700 mb-6">
    After this step, the model looked like this:
</p>
<img src={w3_62} alt="Completed Model" class="my-4 mx-auto rounded shadow-md" />

<h3>Parametric Adjustability and Expandability</h3>
<p class="text-justify text-gray-700 mb-6">
    One of the key requirements for the parametric construction kit was that it should be <strong>adaptable and expandable</strong> in multiple ways. This was achieved by designing the model with an <strong>even number of slots</strong>, allowing half of the columns to be mounted upwards and the other half downwards.
</p>

<p class="text-justify text-gray-700 mb-6">
    To visualize this, I mirrored the upper part in <strong>Fusion 360</strong> to demonstrate its feasibility.
</p>
<img src={w3_75} alt="Mirrored Upper Part in Fusion 360" class="my-4 mx-auto rounded shadow-md" />

<p class="text-justify text-gray-700 mb-6">
    As shown in the following images, the design allows for adjustments such as the number of slots, the diameters of the plates, and the distance between the plates.
</p>
<img src={w3_77}alt="Adjustable Parameters in the Design" class="my-4 mx-auto rounded shadow-md" />
<img src={w3_63} alt="Slot and Plate Adjustments" class="my-4 mx-auto rounded shadow-md" />
<img src={w3_68}alt="Expanded Configuration" class="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6"></p>

{/* Result of the Parametric Construction Kit Section*/}
<div ref={result}>
<h2 className="text-3xl font-bold text-center mb-6">Fabrication of the Parametric Construction Kit</h2>
<h3>Preparing the Model for Laser Cutting</h3>
<p className="text-justify text-gray-700 mb-6">
  To manufacture the model, I adjusted the parameters accordingly and exported the individual sketches as <strong>DXF</strong> files.
</p>
<img src={dxf} alt="DXF Export" className="my-4 mx-auto rounded shadow-md" />

<h3>Setting Up the Laser Cutter</h3>
<p className="text-justify text-gray-700 mb-6">
  Since we were advised to use cardboard, I placed a large piece of cardboard into our <strong>150W GS Laser Cutter</strong> and opened the DXF files in the laser cutter’s software.
</p>
<img src={w3_5} alt="Loading DXF into Laser Software" className="my-4 mx-auto rounded shadow-md" />

<p className="text-justify text-gray-700 mb-6">
  Before starting the cut, the <b>Autofocus</b> needed to be set on the laser cutter. Using the <strong>Origin</strong> and <strong>Frame</strong> functions, I adjusted the position of the design to fit correctly on the material.
</p>
<img src={IMG_20250207_171039_828} alt="Setting Origin and Frame" className="my-4 mx-auto rounded shadow-md" />

<h3>Laser Cutting the Parts</h3>
<p className="text-justify text-gray-700 mb-6">
  After determining the appropriate settings for the cardboard (Speed: 26, Power: 50), I arranged the pieces efficiently and started the cutting process.
</p>
<img src={IMG_20250207_171736_461} alt="Laser Cutting in Progress" className="my-4 mx-auto rounded shadow-md" />
<img src={IMG_20250207_172821_666} alt="Completed Laser Cuts" className="my-4 mx-auto rounded shadow-md" />

<h3>Laser Cutting Video</h3>
<p className="text-justify text-gray-700 mb-6">
  Here is a video of the laser cutter in action. I explained how I compressed the video in <strong>Assignment 2</strong>.
</p>
<video controls className="my-4 mx-auto rounded shadow-md">
  <source src={smallVideo} type="video/mp4" />
</video>


<h3>Assembling the Parts</h3>
<p className="text-justify text-gray-700 mb-6">
  Once all parts were cut, the exciting part began – assembling the pieces and checking if everything fit together properly.
</p>
<img src={w_80} alt="Assembling the Parts" className="my-4 mx-auto rounded shadow-md" />

<h3>Successful Assembly</h3>
<p className="text-justify text-gray-700 mb-6">
  Relief! The pieces fit together perfectly without any issues. The small cardboard table was even strong enough to support objects.
</p>
<img src={w_8} alt="Assembled Structure Holding Objects" className="my-4 mx-auto rounded shadow-md" />

<h3>Final Thoughts</h3>
<p className="text-justify text-gray-700 mb-6">
  I was extremely happy that my first attempt worked flawlessly. Seeing my own <strong>3D design</strong> turn into a real, tangible object was a truly rewarding experience.
</p>
<img src={final_pck} alt="Final Parametric Construction Kit" className="my-4 mx-auto rounded shadow-md" />

</div>
<h3 className="text-xl font-bold text-center mt-8 mb-4">Downloads</h3>
    <ul>
  <li><a href="https://fabacademy.org/2025/labs/bottrop/students/annasophia-brokuf/files/pillar.dxf" download>📎Download Pillar</a></li>
  <li><a href="https://fabacademy.org/2025/labs/bottrop/students/annasophia-brokuf/files/bottom_plate.dxf" download>📎 Download Bottom Plate</a></li>
  <li><a href="https://fabacademy.org/2025/labs/bottrop/students/annasophia-brokuf/files/top_plate.dxf" download>📎Download Top Plate </a></li>
  <li><a href="https://fabacademy.org/2025/labs/bottrop/students/annasophia-brokuf/files/parametric_construction_kit.f3d" download>📎Download Fusion File </a></li>
</ul>


      {/* Vinyl Cutting*/}
      <div ref={vinylCutting}>
      <h2 className="text-3xl font-bold text-center mb-6">Vinyl Cutting</h2>
<p className="text-justify text-gray-700 mb-6">
  This part of the assignment focuses on using a vinyl cutter to create custom designs. The process involves selecting an image, converting it into a vector format, and preparing it for cutting. Vinyl cutting is useful for making stickers, labels, or custom t-shirt or hoodie-designs.
</p>

<h3>1. Selecting and Preparing the Design</h3>
<p className="text-justify text-gray-700 mb-6">
  The first step in the vinyl cutting process is selecting a design. I chose an image that I wanted to cut and downloaded the file. Once the image was ready, I opened <strong>Inkscape</strong> by pressing <code>Ctrl + O</code> and selecting my file.
</p>

<img src={v1} alt="Selecting the Design" className="my-4 mx-auto rounded shadow-md" />

<h3>2. Converting the Image to a Vector Graphic</h3>
<p className="text-justify text-gray-700 mb-6">
  Since vinyl cutters require vector files, the next step was to convert the image into a vector format. In Inkscape, I used the <strong>"Trace Bitmap"</strong> function to generate a vector graphic from the image. This step is crucial because it transforms the pixel-based image into a scalable vector file that the cutter can follow precisely.
</p>

<img src={v2} alt="Tracing the Bitmap" className="my-4 mx-auto rounded shadow-md" />

<p className="text-justify text-gray-700 mb-6">
  After tracing, I removed the original non-vectorized image. A quick tip to distinguish between the two: the non-vectorized version typically has more white space around it. Deleting the original image ensures that only the clean vector graphic remains in the file.
</p>
<img src={v3} alt="Tracing the Bitmap" className="my-4 mx-auto rounded shadow-md" />
<h3>3. Saving the File in SVG Format</h3>
<p className="text-justify text-gray-700 mb-6">
  Once I had the vectorized version of my design, I saved the file in <strong>.svg</strong> format. This format is widely compatible with vinyl cutting software and preserves all necessary vector information.
</p>

<img src={v4} alt="Saving as SVG" className="my-4 mx-auto rounded shadow-md" />
<img src={v5} alt="Saving as SVG" className="my-4 mx-auto rounded shadow-md" />

<h3>4. Preparing for Cutting</h3>
<p className="text-justify text-gray-700 mb-6">
  With the SVG file ready, I imported it into the vinyl cutter software (Cricut) At this stage, I adjusted the cutting settings,
   including blade pressure and speed, depending on the type of vinyl. Usually we use the settings "Every-Day Iron On" for foil used for t-shirts or vinyl for stickers.
</p>
<img src={v6} alt="Software" className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">
  The design was imported into the Cricut Design Space software, where it was prepared for cutting.
</p>
<img src={v7} alt="Adjusting the design in Cricut Software" className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">
  The design was resized and positioned correctly on the virtual cutting mat within the Cricut software.
</p>

<img src={v9} alt="Selecting material type in Cricut Software" className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">
  The correct material type was selected, ensuring the blade pressure and speed settings matched the chosen vinyl.
</p>


<p className="text-justify text-gray-700 mb-6">
  The vinyl sheet was placed onto the cutting mat and loaded into the Cricut machine.
</p>

<img src={v10} alt="Starting the cutting process on the Cricut machine" className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">
  The cutting process was started, with the machine precisely following the vector paths.
</p>

<img src={v11} alt="Removing excess vinyl after cutting" className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">
  After the cutting was complete, the excess vinyl was carefully removed (weeding process).
</p>

<img src={v12} alt="Applying transfer tape to the vinyl design" className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">
  Transfer tape was applied to lift the vinyl design from the backing for easy application.
</p>

<img src={v13} alt="Final vinyl application" className="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">
  The vinyl design was applied to the final surface, completing the cutting and transfer process.
</p>
<p className="text-justify text-gray-700 mb-6">
</p>
<div ref={groupAssignment}></div>
<h2 class="text-2xl font-bold text-left mb-6">Group Assignment</h2>

  <h2 class="text-2xl font-bold text-left mb-6">Characterizing Our Laser Cutter</h2>

  <h3 class="text-2xl font-bold mb-4">Safety Training</h3>
  <p  className="text-justify text-gray-700 mb-6">
  Before using the laser cutter, all team members completed
the required safety training for our lab. This training covered
important aspects such as fire prevention, proper
ventilation, handling of materials, and emergency
procedures. A key takeaway was the importance of always
monitoring the machine while it is operating, as well as
understanding material safety to prevent hazardous fumes
from materials such as PVC. A more detailed description can
be found at a the designated part of the group assignment.
  </p>

  <h3 class="text-2xl font-bold mb-4">Overview of the Epilog Zing 50W</h3>
  <p className="text-justify text-gray-700 mb-6">
    The laser cutter available in our lab is the <strong>Epilog Zing 50W</strong>, a high-precision CO₂ laser system that allows for both 
    <strong>engraving and cutting</strong> on a variety of materials. Below are its specifications:
  </p>

  <ul class="list-disc ml-6 text-gray-700">
    <li><strong>Workspace:</strong> 610 x 305 mm</li>
    <li><strong>Engraving Speed:</strong> 14.45 min (varies based on material and settings)</li>
    <li><strong>Resolution:</strong> Adjustable from 150 dpi to 1000 dpi</li>
  </ul>

  <p className="text-justify text-gray-700 mb-6">To work with the machine, you need to turn it and its ventilation on. The power button of the Airflow Control is located at the lower part of the laser cutter and the power button in the right side.</p>
  <img src={GA1} alt="Airflow Power Button" class="my-4 mx-auto rounded shadow-md" />

  <p className="text-justify text-gray-700 mb-6">For airflow control, there is a small manometer with a handle mounted on the wall.</p>
  <img src={GA2} alt="Manometer for Airflow Control" class="my-4 mx-auto rounded shadow-md" />

  <p className="text-justify text-gray-700 mb-6">To operate the machine, use one of the computers next to it. Open your file in Inkscape and press the "Open in VisiCut" button to adjust the laser settings.</p>
  <img src={GA3} alt="VisiCut Software Interface" class="my-4 mx-auto rounded shadow-md" />
  <p className="text-justify text-gray-700 mb-6">When you're done with your setting you can send your file to
the laser cutter and start your job.
But don't forget to set the focus depending on your material
strength! You can find the focus button on the panel at the
right. Press focus and raise or lower the bed by pressing the
arrows up or down depending on the material strength.</p>
  <p className="text-justify text-gray-700 mb-6">Before starting the job, set the correct focus based on material thickness using the panel buttons.</p>
  <img src={GA4} alt="Focus Setting on Laser Cutter" class="my-4 mx-auto rounded shadow-md" />

  <p className="text-justify text-gray-700 mb-6">Once you have set the correct distance between the
  pendulum and the material it should look like in this video:</p>
  <video controls className="my-4 mx-auto rounded shadow-md">
  <source src={focus} type="video/mp4" />
</video>


  <h3 class="text-2xl font-bold mb-4">Engravable Materials</h3>
  <p className="text-justify text-gray-700 mb-6">The laser cutter is capable of engraving a wide range of
  materials, including:</p>
  <ul class="list-disc ml-6  text-gray-700 mb-6">
    <li>Stainless steel (with marking spray)</li>
    <li>Laminate-based plastics</li>
    <li>Acrylic/Plexiglass</li>
    <li>Painted metals</li>
    <li>Anodized aluminum</li>
    <li>Wood, plywood, MDF, and veneer</li>
    <li>Leather, rubber, and cork</li>
    <li>Paper, cardboard, and paperboard</li>
    <li>Fabrics and textiles</li>
    <li>Organic materials such as food (e.g., apples or bananas)</li>
  </ul>

  <h3 class="text-2xl font-bold mb-4">Cuttable Materials</h3>
  <ul class="list-disc ml-6 text-gray-700 mb-6">
    <li>Laminate-based plastics</li>
    <li>Acrylic/Plexiglass</li>
    <li>Wood, plywood, MDF, and veneer</li>
    <li>Paper, cardboard, and paperboard</li>
    <li>Cork</li>
    <li>Thin foils</li>
    <li>Leather and rubber</li>
    <li>Fabrics and textiles</li>
  </ul>

  <h3 class="text-2xl font-bold mb-4">Power and Speed</h3>
  <p className="text-justify text-gray-700 mb-6">
  Power refers to the amount of laser energy delivered to the
material, typically adjustable from 0% to 100%. Higher power
settings result in deeper cuts or engravings but can cause
charring or excessive melting if not properly managed.
Speed determines how quickly the laser head moves across
the material. Slower speeds increase exposure time, leading
to deeper cuts, while faster speeds result in shallower cuts or
surface markings.
Balancing Power and Speed: The interplay between power
and speed is crucial. For instance, cutting thicker materials
Laminate-based plastics
Acrylic/Plexiglass
Wood, plywood, MDF, and veneer
Paper, cardboard, and paperboard
Cork
Thin foils
Leather and rubber
Fabrics and textiles
may require high power combined with slower speeds to
ensure a complete cut. Conversely, engraving delicate
patterns on sensitive materials might necessitate lower power
and higher speeds to prevent damage.
For our tests, we used 3mm plywood and used fields with the
different parameters for Cut Speed and Cut Power.
Here you can see our template, that we adjusted for our laser may require high power combined with slower speeds to
ensure a complete cut. Conversely, engraving delicate
patterns on sensitive materials might necessitate lower power
and higher speeds to prevent damage.
For our tests, we used 3mm plywood and used fields with the
different parameters for Cut Speed and Cut Power.
Here you can see our template, that we adjusted for our laser
cutter   </p>
<img src={GA5} alt="Picture Template" class="my-4 mx-auto rounded shadow-md" />

<p className="text-justify text-gray-700 mb-6">Here you can see the different colors in visicut that belong to
different settings of the cut power, cut speed, engraving
speed and engraving power.</p>

  <p className="text-justify text-gray-700 mb-6">And here are the different settings visualized in VisiCut:</p>
  <img src={GA6}  alt="VisiCut Settings" class="my-4 mx-auto rounded shadow-md" />

  <p className="text-justify text-gray-700 mb-6">The engraving section shows the impact of various power and speed settings:</p>
<p className="text-justify text-gray-700 mb-6">On the bottom of our test card we have demonstrated the
different values for engrave speed and engrave power</p>

<img src={GA8} alt="Testcard" class="my-4 mx-auto rounded shadow-md" />


<p className="text-justify text-gray-700 mb-6">From our laser cutter test card, we can clearly observe the
impact of power and speed settings on both cutting and
engraving results.
In the cutting section of the test card, we can see how
different combinations of cut power and cut speed affect the
ability of the laser to penetrate the 3mm plywood. Higher
power levels combined with lower speed settings result in
cleaner, more defined cuts, while lower power or higher
speed settings leave incomplete or shallow cuts. The burn
marks around the cut holes also indicate that excessive
power at lower speeds leads to charring, which might
require post-processing like sanding or cleaning.
In the engraving section, the differences between engrave
power and engrave speed are particularly noticeable.
Higher power settings produce darker and deeper
engravings, while lower power results in lighter surface
markings. Additionally, at lower speeds, the laser has more
time to burn into the material, causing deeper and darker
engravings, whereas at higher speeds, the engraving
appears lighter and more subtle. In our test, this is especially
evident in the middle row, where excessive heat buildup at
certain power levels resulted in overburning and uneven
coloration.</p>


  <h3 class="text-2xl font-bold mb-4">Frequency</h3>
  <p className="text-justify text-gray-700 mb-6">
  Frequency pertains to the number of laser pulses emitted per second, measured in Hertz (Hz).
  In vector cutting mode, adjusting the frequency influences the smoothness and quality of the cut:

  </p>
  <p className="text-justify text-gray-700 mb-6">- High Frequency: Produces a continuous cut with smoother edges but can generate more heat, potentially causing charring on materials like wood.</p>
  <p className="text-justify text-gray-700 mb-6">- Low Frequency: Results in a series of closely spaced pulses, which can be beneficial for cutting heat-sensitive materials by reducing thermal accumulation.</p>

  <img src={GA9}  alt="Frequency Settings in VisiCut" class="my-4 mx-auto rounded shadow-md" />
<p className="text-justify text-gray-700 mb-6">The frequency range goes from 0 - 5000Hz. For the illustration, we worked with 2%, 10%, 20%, 50% and 100% of the frequency (which is 100, 500, 1000, 2500 and 5000 Hz) and used a power / speed of 70 / 30 and 30 / 70. You can see from the result that the row with power 70 was cut completely. On the row with the lower thickness of 30, you can see that the cut lines are perforated and the material has therefore remained in place and has not been completely cut out.</p>
<img src={GA10}  alt="Frequency Test" class="my-4 mx-auto rounded shadow-md" />

  <h3 class="text-2xl font-bold mb-4">Kerf</h3>
  <p className="text-justify text-gray-700 mb-6">
  Kerf is the width of material removed by the laser beam during cutting. It is influenced by factors such as laser power, cutting speed, material type, and focus. Accurately accounting for kerf is essential for designing parts that fit together precisely, especially in press-fit assemblies.
  </p>

  <img src={GA11}  alt="Kerf Measurement 1" class="my-4 mx-auto rounded shadow-md" />
  <img src={GA12} alt="Kerf Measurement 2" class="my-4 mx-auto rounded shadow-md" />
  <img src={GA13} alt="Kerf Measurement 3" class="my-4 mx-auto rounded shadow-md" />
  <img src={GA14} alt="Kerf Measurement 4" class="my-4 mx-auto rounded shadow-md" />
  <img src={GA15}alt="Kerf Measurement 5" class="my-4 mx-auto rounded shadow-md" />




  <p className="text-justify text-gray-700 mb-6">From our measurements, you can see, that the kerf lies between 0.09 and 0.17mm. This means that this value would have to be subtracted when designing a press-fit kit in order to produce accurately fitting parts, as this part is removed during the laser cutter's cutting process. </p>

</div>

      </div>
      </div>

  );
};

export default Assignment4;